import React from 'react';

export default class Treatment extends React.Component {
  render() {
    return <div className="columns">
      <div className="column"></div>
      <div className="column content">
        Discover new and better Bipolar treatments.<br/>
        Become a more active agent in your care with this free access code:
      </div>
      <div className="column"></div>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/landing/Treatment.js